import { render, staticRenderFns } from "./ClaimsActivities.vue?vue&type=template&id=0a52d9b4"
import script from "./ClaimsActivities.vue?vue&type=script&lang=ts"
export * from "./ClaimsActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports